import { DatePipe } from '@angular/common';
import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate',
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(
    value: Date | string | number | null | undefined,
    pattern = 'mediumDate'
  ): string {
    const datePipe: DatePipe = new DatePipe(this.translateService.currentLang);

    return datePipe.transform(value, pattern) || '';
  }
}
